import React, { useEffect, useState } from 'react';
import { cn } from '@bem-react/classname';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RegContext } from './RegContext';
import { translation } from '../../../translations/registrationForm/translation';
import {  getLang } from '../../../common';
import StepSwitcher from './stepSwitcher';
import LoadingSpinner from '../../ui/loadingSpinner';
import './style.scss';
import { getCountryNames, getCurrencyData } from '../../../api/Registration/api';
import { getReCaptchaSiteKey } from '../../../config';

export const registrationCn = cn('Registration');

const Registration = ({
  brandName,
  lang,
  langId,
  defaultCountryId,
  defaultCurrencyId,
  defaultPromoCode,
  finishBtn,
  regFormTitle,
  landingName,
  regWith,
  isNeedlog,
}) => {
  const countryJsonDev = require('../../../../static/data/country_data_dev.json');
  const [wait, setWait] = useState(true);
  const [countryJson, setCountryJson] = useState(null);
  const [currencyData, setCurrencyData] = useState('');
  const [countryData, setCountryData] = useState('');
  const [state, setState] = useState({
    step: 1,
    formData: '',
  });
  const [isCountryListOpen, setIsCountryListOpen] = useState(false);
  const [isCurrencyListOpen, setIsCurrencyListOpen] = useState(false);

  useEffect(() => {
    const getCountryData = async (brandName, lang) => {
      const res = await getCountryNames(brandName, lang);
      setCountryJson(res);
    };

    try {
      getCountryData(brandName, lang);
    } catch (err) {
      if (!res) {
        setCountryJson(countryJsonDev);
      }
    }
  }, []);

  useEffect(() => {
    if (countryJson) {
      initCountryData();
      initCurrencyData();
    }
  }, [countryJson]);

  const initCountryData = async () => {
    const getCountryData = () => {
      let newData = Object.values(countryJson).map((code) => {
        code.name = code.name.toLowerCase();
        return code;
      });
      newData = newData.filter((item) => {
        if (item !== undefined && item !== null) {
          return item;
        }
      });
      setCountryData(newData);
    };
    await getCountryData();
  };

  const initCurrencyData = async () => {
    const currencyData = await getCurrencyData(brandName, lang);
    setCurrencyData(currencyData);
    setWait(false);
  };

  const updateData = (object) => {
    setState({
      ...state,
      ...object,
    });
  };
  const reg = (
    <RegContext.Provider
      value={{
        state,
        updateData,
        isCountryListOpen,
        setIsCountryListOpen,
        isCurrencyListOpen,
        setIsCurrencyListOpen,
      }}
    >
      <GoogleReCaptchaProvider reCaptchaKey={getReCaptchaSiteKey()} useEnterprise>
        <StepSwitcher
          step={state.step}
          brandName={brandName}
          lang={lang}
          langId={langId}
          translationForReg={translation}
          formData={state.formData}
          countryData={countryData}
          currencyData={currencyData}
          defaultCountryId={defaultCountryId}
          defaultCurrencyId={defaultCurrencyId}
          defaultPromoCode={defaultPromoCode}
          finishBtn={finishBtn}
          regFormTitle={regFormTitle}
          landingName={landingName}
          regWith={regWith}
          isNeedlog={isNeedlog}
        />
      </GoogleReCaptchaProvider>
    </RegContext.Provider>
  );

  const regLoad = (
    <div className={registrationCn()}>
      <div className={registrationCn('Title')}>
        {getLang(translation, brandName, lang, 'formSubtitle')}
      </div>
      <div className="spinner">
        <LoadingSpinner />
      </div>

      {state.step !== 3 ? (
        <div className={`${registrationCn('Rules')} ${registrationCn(`Rules_${lang}`)}`}>
          {getLang(translation, brandName, lang, 'disclaimerText1')}
          <a onClick={() => setCompanyRulesOpen(true)}>
            {getLang(translation, brandName, lang, 'disclaimerRules')}
          </a>
          {getLang(translation, brandName, lang, 'disclaimerText2')}
          <a onClick={() => setPrivacyPolicyOpen(true)}>
            {getLang(translation, brandName, lang, 'disclaimerPrivacyPolicy')}
          </a>
          {getLang(translation, brandName, lang, 'disclaimerText3')}
        </div>
      ) : null}
    </div>
  );
  // {
  // 	state.step !== 3 ? (
  // 		<>
  // 			<Modal onClose={modalHandler} className='Registration-modal' visible={companyRulesOpen} title={getLang(translation, brandName, lang, 'betAcceptanceRules')}>
  // 				<div className='static-html' dangerouslySetInnerHTML={{ __html: companyRules }} />
  // 			</Modal>
  // 			<Modal onClose={modalHandler} className='Registration-modal' visible={privacyPolicyOpen} title={getLang(translation, brandName, lang, 'privacyPolicy')}>
  // 				<div className='static-html' dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
  // 			</Modal>
  // 		</>
  // 	) : null
  // }

  return <>{wait ? regLoad : reg}</>;
};

export default Registration;
